import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

export type TIcon = '24-month-calendar' |
    'apple' |
    'bags-trolley' |
    'bags-trolley-premium' |
    'bags-trolley-star' |
    'bags-trolley-stars' |
    'bed-front' |
    'breakfast' |
    'building' |
    'calculate-time' |
    'check' |
    'close' |
    'couples-bags' |
    'edit' |
    'facebook' |
    'five-stars-hotel' |
    'google' |
    'instagram' |
    'linkedin' |
    'novo-logo-montreal-invertido' |
    'persons' |
    'sash'    |
    'single-bag' |
    'user' |
    'without-money' |
    'youtube' |
    'youtube-play' |
    '' ;
@Component({
  selector: 'app-svg-icon',
  template: `<div class="app-svg-icon">
    <span class="app-svg-icon__item"
          [innerHTML]="svgIcon"
          [style.color]="fill"
          [style.height]="height"
          [style.width]="width"
          [style.display]="flex ? 'flex' : 'inline-block'">
    </span>
  </div>`,
  styleUrls: ['./svg-icon.component.sass']
})
export class SvgIconComponent implements OnInit, OnChanges {

  constructor(
      private httpClient: HttpClient,
      private sanitizer: DomSanitizer
  ) { }
  @Input() icon?: string;
  @Input() fill?: string;
  @Input() stroke?: string;
  @Input() height?: string;
  @Input() width?: string;
  @Input() flex?: boolean;
  svgIcon: SafeHtml;
  ngOnInit() {
    this.fill = this.fill !== '' ? this.fill : '';
    this.icon = this.icon !== '' ? this.icon : 'edit';
    this.stroke = this.stroke !== '' ? this.stroke : '#112211';
    this.height = this.height !== '' ? this.height : '';
    this.width = this.width !== '' ? this.width : '';
    this.flex = this.flex !== undefined ? this.flex : false;
  }

  ngOnChanges() {
    if (!this.icon) {
      this.svgIcon = '';
      return;
    }
    this.httpClient
        .get(`assets/svg/${this.icon}.svg`, {responseType: 'text'})
        .subscribe(value => {
          this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
        });
  }
}
